import styled, { keyframes } from 'styled-components';
import { shade } from 'polished';
import ImgLogin from '../../assets/sign-in-background.png';

const appearFromLeft = keyframes`
  from {
    opacity: 0;
    transform: translateX(-70px);
  }
  to{
    opacity: 1;
    transform: translateX(0);
  }
`;

export const Container = styled.div`
  /* Tem 100% da parte visível da tela que o usuário consegue ver */
  height: auto;
  /**Faz os items de dentro ficar todos um do lado do outro. */
  display: flex;
  /* Faz os items de dentro ter o mesmo tamanho, no caso, o tamanho de
  100vh */

  //background-image: linear-gradient(#006000, #111111);
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  width: 100%;
  max-width: auto;
  min-height: 100vh;
`;

export const AnimationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  animation: ${appearFromLeft} 1s;

  img {
    //margin-right: 30px;
    width: 290px;
    height: 200px;
  }

  form {
    //margin: 49px 0;
    width: 340px;

    h1 {
      font-weight: bold;
    }

    a {
      color: #f4ede8;
      display: block;
      margin-top: 24px;
      text-decoration: none;
      transition: color 0.2s;

      &:hover {
        color: ${shade(0.2, '#f4ede8')};
      }
    }
  }

  > a {
    color: #ffffff;
    display: block;
    margin-top: 24px;
    text-decoration: none;
    transition: color 0.2s;
    margin-bottom: 10px;
    font-family: 'Roboto', sans-serif;

    svg {
      margin-right: 8px;
    }

    &:hover {
      color: ${shade(0.2, '#ffffff')};
    }

    display: flex;
  }

  /**Ele estiliza apenas o 'a' que estar dentro do content. Assim, ele não
  sobrescreve nenhuma estilização de quaisquer outro 'a' que esteja em outro
  componente. */
`;

export const Background = styled.div`
  flex: 1;
  background: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)),
    url(${ImgLogin}) no-repeat center;//url(${ImgLogin}) no-repeat center;
  background-size: cover;
`;
